import React, { Component } from 'react';
import dynamic from 'next/dynamic';
import Image from 'next/image';
import PropTypes from 'prop-types';
import Link from '../../../public/assets/link';

const Icon = dynamic(() => import('../Icons/Icon'));


export default class ArticleBlock extends Component {
  state = {
    isCopied: false
  }

  copyToClipboard = () => {
    navigator.clipboard.writeText(this.props.article_link);
    this.setState({ isCopied: true });
    setTimeout(() => {
      this.setState({ isCopied: false });
    }, 2000);
  }

  render() {
    const s = require('./article-block.module.scss');
    const { fullname, avatar, facebook_link, twitter_link, linkedin_link, shortened_link, postTakeover } = this.props;
    return (
      <div className={postTakeover ? s.TakeoverBlockWrapper : s.BlockWrapper}>
        <div className={s.BlockAvatar}>
          <div className={s.BlockAuthor}>
            {avatar.thumb.large && <Image className={s.Avatar} src={avatar.thumb.large} alt="thumb" width={40} height={40} />}
            <h3>{fullname}</h3>
          </div>
          <div className={s.BlockSocial}>
            <a href={facebook_link} target="_blank" rel="noopener noreferrer"><Icon className={s.socials} icon="SOCIAL_FACEBOOK" theme="facebook" size={17} /></a>
            <a href={twitter_link} target="_blank" rel="noopener noreferrer"><Icon className={s.socials} icon="SOCIAL_TWITTER" theme="twitter" size={17} /></a>
            <a href={linkedin_link} target="_blank" rel="noopener noreferrer"><Icon className={s.socials} icon="SOCIAL_LINKEDIN" theme="linkedin" size={17} /></a>
          </div>
          <div className={s.BlockLink} onClick={() => this.copyToClipboard()}>
            <button className={this.state.isCopied ? 'isCopied' : ''}>
              <Link />
              <p>{shortened_link}</p>
            </button>
            {this.state.isCopied &&
            <span className={s.CustomToolTip}>Copied to clipboard</span> }
          </div>
        </div>
      </div>
    );
  }
}

ArticleBlock.propTypes = {
  fullname: PropTypes.string,
  avatar: PropTypes.object,
  facebookLink: PropTypes.string,
  twitterLink: PropTypes.string,
  linkedinLink: PropTypes.string,
  articleLink: PropTypes.string,
  shortenedLink: PropTypes.string,
  postTakeover: PropTypes.bool
}